import React, { useState } from "react";

import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import { Btn } from "../../AbstractElements";
import ComponentToView from "./ComponentToView";
import ComponentToPrint from "./ComponentToPrint";
import { Icon } from "@progress/kendo-react-common";

const PreviewModal = (props) => {
  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);
  return (
    <div>
      {/* <Dialog open={props.isOpen} onClose={props.handleClose}>
        <DialogActions></DialogActions>
        <DialogTitle>GG1</DialogTitle>
        <ComponentToView />
      </Dialog> */}
      <Dialog
        maxWidth="md"
        open={props.isOpen}
        onClose={props.handleClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>Blanket GG1</div>
            <div className="d-flex justify-content-end ">
              <Btn
                attrBtn={{
                  className: "m-1",
                  color: "primary",
                  onClick: () => {
                    return props.handlePrint(), props.handleClose();
                  },
                }}
              >
                <Icon style={{ fontSize: "18px", marginRight:"10px" }} name="print" />
                Print
              </Btn>

              <Btn
                attrBtn={{
                  className: "m-1",
                  color: "primary",
                  onClick: props.handleClose,
                }}
              >
                Close
              </Btn>
            </div>{" "}
          </div>
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <ComponentToPrint
            data={props.data}
            approvedData={props?.approvedData}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default PreviewModal;
